<template>
  <div class="container-fluid">
    <div class="row marketing">
      <div class="col-lg-12">
        <h4 class="form-head">
          Important Contacts
        </h4>
        <table class="table table-borderless">
          <thead class="thead-dark">
          <tr>
            <th>Warehouse</th>
            <th>InCharge</th>
            <th>RDM</th>
            <th>Transporter Contact</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="u of contacts" :key="u.id">
            <td>
              <span v-if="u.location && u.location.id">{{u.location.name}}</span>
              <span v-if="!u.location">PAN INDIA</span>
            </td>
            <td>{{u.inchargeName}} <br />{{u.inchargeMobile}}</td>
            <td>{{u.rdmName}} <br />{{u.rdmMobile}}</td>
            <td>
              <ul class="list-group">
                <li class="list-group-item list-group-item-dark">
                  <div v-if="u.transporter && u.transporter.name">{{u.transporter.name}}</div>
                </li>
                <li class="list-group-item" v-for="c in u.trContacts" :key="c.id">
                  <div class="row justify-content-start">
                    <div class="col-2">{{c.name}}</div>
                    <div class="col-2">{{c.mobile}}</div>
                    <div class="col-2">{{c.email}}</div>
                  </div>
                </li>
              </ul>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

let contactUrl = `/app/contact`
let trContactUrl = `/app/contact/transporter`
let locationsUrl = `/app/location`
let apiUrlTransporter = `/app/party?type=TRANSPORTER`

export default {
  name: 'UserPage',
  created: function () {
    this.$store.dispatch('isLoggedIn').then(() => {
      if (!this.$store.state.loggedIn) {
        console.log('Not Logged-in')
        this.$router.push('login')
      }

      this.loadDetails()
    })
  },
  data () {
    return {
      f: {
        id: null,
        location: {
          id: null
        },
        transporter: {
          id: null
        },
        inchargeName: '',
        inchargeMobile: '',
        rdmName: '',
        rdmMobile: '',
        trContacts: [
          {name: '', email: '', mobile: ''}
        ]
      },
      locations: [],
      transporters: [],
      contacts: [],
      trC: {}
    }
  },
  computed: {},
  methods: {
    saveContact: function () {
      console.log('Saving', this.f)
      let f = Object.assign({}, this.f)
      if (f.location.id == null) {
        delete f['location']
      }
      let fPost = Object.assign({}, f)
      delete fPost['trContacts']

      axios.post(contactUrl, fPost)
        .then(response => {
          let posts = f.trContacts.map(trC => {
            let trCPost = Object.assign({}, trC)
            trCPost['contactDetails'] = {id: response.data.id}
            axios.post(trContactUrl, trCPost)
          })

          axios.all(posts)
            .then(axios.spread(() => {
              this.f = {
                id: null,
                location: {
                  id: null
                },
                transporter: {
                  id: null
                },
                inchargeName: '',
                inchargeMobile: '',
                rdmName: '',
                rdmMobile: '',
                trContacts: [
                  {name: '', email: '', mobile: ''}
                ]
              }
              this.loadDetails()
            }))
        }, error => {
          console.error('Error in Saving User', error)
        })
    },
    editTRContact: function (tr) {
      this.trC = Object.assign({}, tr)
      this.$refs.trContactEdit.show()
    },
    saveTRContact: function () {
      axios.post(trContactUrl, this.trC)
        .then(resp => {
          this.loadDetails()
          this.$refs.trContactEdit.hide()
        }, err => {
          console.error('error in saving trContact', err)
        })
    },
    loadDetails: function () {
      axios.all([
        axios.get(apiUrlTransporter),
        axios.get(locationsUrl),
        axios.get(contactUrl)
      ]).then(axios.spread((transporters, locations, contacts) => {
        this.transporters = transporters.data
        this.locations = locations.data
        this.contacts = contacts.data
      }))
    },
    saveTr: tr => {
      axios.post(trContactUrl, tr)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ContactDisplayPage.vue